export default __webpack_public_path__ + "static/media/WhitePawIcon.ace23e0e.svg";